import { render, staticRenderFns } from "./GrammarExplanationForm.vue?vue&type=template&id=48742678&"
import script from "./GrammarExplanationForm.vue?vue&type=script&lang=js&"
export * from "./GrammarExplanationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports